<template>
  <div>
    <div v-if="title" class="mb-3">
      <strong class="fs_16" v-text="title" />
    </div>
    <b-table
      class="bg-white score_competency_table"
      :fields="fields"
      :items="items"
    >
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  }
};
</script>

<style lang="scss">
.score_competency_table {
  tr {
    background-color: #fff !important;
  }
  td {
    &.table-success {
      background-color: #4dbd74 !important;
    }
  }
}
</style>